import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import { PipesModule } from '../../../shared/pipes/pipes.module';

import { GroceryCategoryItemsHorizontalListComponentModule } from '../../../shared/components/grocery-category-items-horizontal-list/grocery-category-items-horizontal-list.module';
import { VendorGroceryCategoriesComponent } from './vendor-grocery-categories.component';

@NgModule({
  declarations: [VendorGroceryCategoriesComponent],
  imports: [CommonModule, IonicModule, PipesModule, TranslateModule.forChild(), GroceryCategoryItemsHorizontalListComponentModule],
  exports: [VendorGroceryCategoriesComponent],
})
export class VendorGroceryCategoriesComponentModule {}
